import type { UtilityContext } from '@change-corgi/core/react/utilityContext';
import type { ImageLocation } from '@change-corgi/middle-end-gql-schema';

import {
	SharedPhotoUploadInfo,
	type SharedPhotoUploadInfoQuery,
	type SharedPhotoUploadInfoQueryVariables,
} from './index.graphql';

export async function getPhotoUploadCredentials(
	name: string,
	{ gql: { fetch } }: UtilityContext,
	imageLocation: ImageLocation,
): Promise<SharedPhotoUploadInfoQuery['photoUploadCredentials']> {
	const { data } = await fetch<SharedPhotoUploadInfoQuery, SharedPhotoUploadInfoQueryVariables>({
		query: SharedPhotoUploadInfo,
		variables: { name, folder: imageLocation },
		rejectOnError: false,
	});

	return data?.photoUploadCredentials || null;
}
